<template>
  <v-textarea
    :value="value"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :height="height || 176"
    box
    :error-messages="getErrors(validator)"
    no-resize
    :hint="hint"
    persistent-hint
    @input="$emit('input', $event); validator && validator.$touch()"
    @blur="validator && validator.$touch()"
  />
</template>

<script>

import { defaultMessages, getValidationErrors } from './../../../utils'

export default {
  name: 'textarea-field',
  props: {
    disabled: Boolean,
    placeholder:{
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    getErrors: function(field){
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
  },
}
</script>

<style>
</style>
